/* eslint-disable no-param-reassign */
import { Enquiry } from 'types'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import getEnquiries, { GetEnquiriesResponse } from 'api/broadcast/getEnquiries'
import handleAxiosError from 'utils/handleAxiosError'
import { RootState } from 'slices/index'

interface BroadcastEnquiriesState {
	enquiries: Array<Enquiry>
	loading: boolean
	page: number
	size: number
	totalCount: number
}

export const getBroadcastEnquiriesAction = createAsyncThunk<
	GetEnquiriesResponse,
	string
>(
	'broadcast/getBroadcastEnquiriesAction',
	async (broadcastId, { rejectWithValue, getState }) => {
		try {
			const state = getState() as RootState
			const { page, size } = state.broadcastEnquiries
			return await getEnquiries({
				broadcast: broadcastId,
				page,
				size,
			})
		} catch (err: any) {
			handleAxiosError(err)
			return rejectWithValue('Failed to fetch broadcast enquiries')
		}
	}
)

const initialState: BroadcastEnquiriesState = {
	enquiries: [],
	loading: false,
	page: 1,
	size: 10,
	totalCount: 0,
}

const broadcastEnquiriesSlice = createSlice({
	name: 'broadcastEnquiries',
	initialState,
	reducers: {
		setBroadcastEnquiriesPage(state, action) {
			state.page = action.payload
		},
	},
	extraReducers: builder => {
		builder.addCase(getBroadcastEnquiriesAction.pending, state => {
			state.loading = true
		})
		builder.addCase(
			getBroadcastEnquiriesAction.fulfilled,
			(state, { payload }) => {
				state.loading = false
				state.enquiries = payload.records
				state.totalCount = payload.totalCount
			}
		)
		builder.addCase(getBroadcastEnquiriesAction.rejected, state => {
			state.loading = false
		})
	},
})

export const { setBroadcastEnquiriesPage } = broadcastEnquiriesSlice.actions
export default broadcastEnquiriesSlice.reducer
